import SCRender31 from './SCRender31.vue'
import SCRender4 from './SCRender4.vue'
import SCRender7 from './SCRender7.vue'
import SCRender8 from './SCRender8.vue'
import SCRenderBase from './SCRenderBase.vue'
import SCRenderOther11 from './SCRenderOther11.vue'

// 通过子题类型base_question_type来确定子题渲染所用组件
const SubContentRenderMap = [
  {
    base_question_type: [1, 3, 5, 6, 9, 10, 16, 25, 29, 30],
    component: SCRenderBase
  },
  {
    base_question_type: 4, // 填空
    component: SCRender4
  },
  {
    base_question_type: [7, 27], // 连线
    component: SCRender7
  },
  {
    base_question_type: [8, 28], // 归类
    component: SCRender8
  },
  {
    base_question_type: 31, // 中学OT0小题
    component: SCRender31
  }
]

// 通过大题干question_type来确定子题的渲染方式。例如完形填空(11)
const SubContentRenderMap2 = [
  {
    question_type: 11, // 完形填空
    component: SCRenderOther11
  }
]

export { SubContentRenderMap, SubContentRenderMap2 }
